import * as yup from "yup";
import { ContentBlockData, ContentBlockSchema } from "./";

export interface ContentHeroData extends ContentBlockData {
    body?: string;
    image?: string;
}

export const ContentHeroSchema = yup.object().shape({
    body: yup.string().required().max(4000).label("Description"),
    image: yup.string().required().max(255).label("Hero image"),
}).concat(ContentBlockSchema);



// WEBPACK FOOTER //
// ./src/forms/adminPage/ContentHero.ts